// externals
import React from 'react';
import { Action } from '@interstate/components/Action';
import { Heading } from '@makemydeal/dr-ui-bricks-components';
import { OptionalPackages } from './content/OptionalPackages';
import { StandaloneOptions } from './content/StandaloneOptions';
import { TrimHighlights } from './content/TrimHighlights';
import { Wrapper, HeaderSection, BottomRow, ViewAllLink, ViewAllLabel } from './PackagesSection.style';
import { ChevronRightIcon } from '../icons/ChevronRightIcon';
import { StandardFeaturesSlideout } from '../StandardFeaturesSlideout/StandardFeaturesSlideout';

// types
import type { PackagesSectionViewModel } from '../../types/InstalledOptionalEquipmentProps';

export const PackagesSection: React.FC<{ packagesEquipment: PackagesSectionViewModel }> = ({ packagesEquipment }) => {
    const {
        hasEquipment,
        trim,
        optionalPackages,
        standaloneOptions,
        trimHighlights,
        hasPackages,
        hasStandalone,
        hasHighlights,
        showBottomRow,
        allExpanded,
        isStandardFeaturesOpen,
        isPackageExpanded,
        togglePackage,
        toggleExpandCollapseAll,
        openStandardFeatures,
        closeStandardFeatures
    } = packagesEquipment;

    if (!hasEquipment) {
        return null;
    }

    return (
        <Wrapper data-testid="packages-section">
            <HeaderSection>
                <Heading level={6} weight="bold" as="h2">
                    Installed Optional Equipment
                </Heading>
                <ViewAllLink>
                    <Action data-testid="view-standard-features" onClick={openStandardFeatures} size="sm">
                        <ViewAllLabel size="xsmall" weight="semibold" forwardedAs="span">
                            View All Features
                        </ViewAllLabel>
                        <ChevronRightIcon />
                    </Action>
                </ViewAllLink>
            </HeaderSection>

            {hasPackages && (
                <OptionalPackages
                    optionalPackages={optionalPackages}
                    allExpanded={allExpanded}
                    isPackageExpanded={isPackageExpanded}
                    togglePackage={togglePackage}
                    toggleExpandCollapseAll={toggleExpandCollapseAll}
                />
            )}

            {showBottomRow && (
                <BottomRow $showTopBorder={hasPackages} $stacked={!hasPackages}>
                    {hasStandalone && <StandaloneOptions options={standaloneOptions} stacked={!hasPackages} />}
                    {hasHighlights && <TrimHighlights trim={trim} highlights={trimHighlights} />}
                </BottomRow>
            )}

            <StandardFeaturesSlideout show={isStandardFeaturesOpen} onHide={closeStandardFeatures} />
        </Wrapper>
    );
};
